"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const styles_1 = require("@mui/styles");
exports.useStyles = (0, styles_1.makeStyles)(theme => ({
    root: {
        fontStyle: "italic",
        color: theme.palette.grey[800],
        borderLeft: `4px solid ${theme.palette.grey.A100}`,
    },
}), { name: "Blockquote" });
//# sourceMappingURL=styles.js.map